var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScalableCamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.35,
    height: 41.349,
    viewBox: "0 0 41.35 41.349",
    fill: "#5D44FF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "viral-marketing_11526578",
    transform: "translate(-3.999 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M44.892,4.057A.738.738,0,0,0,44.61,4H38.7a.738.738,0,0,0,0,1.477h4.125l-5.641,5.642a18.524,18.524,0,0,0-25.029,0L6.521,5.477h4.125a.738.738,0,1,0,0-1.477H4.738A.746.746,0,0,0,4,4.738v5.907a.738.738,0,1,0,1.477,0V6.521l6.145,6.145a.772.772,0,0,0,1.141-.094c10.7-10.605,29.163-2.729,28.892,12.384a17,17,0,0,1-17.261,16.7c-13.188-.1-21.284-15.276-13.927-26.272a.739.739,0,0,0-.275-1.008.758.758,0,0,0-1.05.339,18.552,18.552,0,0,0,1.975,22.474c-.112.11-5.7,5.705-5.64,5.638,0-.129,0-4.123,0-4.162A.739.739,0,0,0,4,38.705c0,.158,0,5.908,0,5.946a.767.767,0,0,0,.739.7c.156,0,5.9,0,5.944,0a.739.739,0,0,0-.041-1.476c-.092,0-4.278,0-4.121,0,.074-.074,5.613-5.816,5.739-5.549a18.525,18.525,0,0,0,24.927-.089c.11.112,5.7,5.7,5.638,5.64-.13,0-4.122,0-4.162,0a.739.739,0,0,0,.041,1.476c.158,0,5.908,0,5.946,0a.767.767,0,0,0,.7-.739c0-.156,0-5.9,0-5.944a.738.738,0,0,0-.777-.7.753.753,0,0,0-.7.739c0,.092,0,4.277,0,4.121-.075-.075-5.811-5.612-5.549-5.739a18.526,18.526,0,0,0-.089-24.926c.112-.11,5.7-5.705,5.64-5.638,0,.131,0,4.121,0,4.162a.738.738,0,0,0,.777.7.758.758,0,0,0,.7-.739c0-.158,0-5.908,0-5.946A.744.744,0,0,0,44.892,4.057Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M26.767,41.562A14.784,14.784,0,0,0,41.535,26.794C40.724,7.2,12.808,7.209,12,26.795A14.784,14.784,0,0,0,26.767,41.562Zm0-28.058A13.306,13.306,0,0,1,40.058,26.794c-.73,17.632-25.854,17.627-26.581,0A13.306,13.306,0,0,1,26.767,13.5Z",
    transform: "translate(-2.093 -2.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M19.477,31.751h.971v3.763a2.215,2.215,0,0,0,4.43,0V31.751h.476a6.629,6.629,0,0,1,5.96,3.761,2.211,2.211,0,0,0,4.407-.229V22.223a2.21,2.21,0,0,0-4.407-.228,6.629,6.629,0,0,1-5.96,3.761H19.477A1.478,1.478,0,0,0,18,27.232v3.042a1.478,1.478,0,0,0,1.477,1.477Zm3.186,4.5a.739.739,0,0,1-.738-.738V31.751H23.4v3.763a.739.739,0,0,1-.738.738Zm10.1-14.029a.738.738,0,1,1,1.477,0V35.284a.738.738,0,0,1-1.477,0Zm-1.477,2.4v8.251a8.211,8.211,0,0,0-6.413-2.6V27.232a8.211,8.211,0,0,0,6.413-2.6Zm-11.814,2.6H23.4v3.042H19.477Z",
    transform: "translate(-3.663 -4.194)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScalableCamp);
export default __webpack_public_path__ + "static/media/scalable-camp.ddd74de994c7a41a67e68b55a2b740f8.svg";
export { ForwardRef as ReactComponent };